import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  ADS,
  DISPLAY_EMAIL,
  DISPLAY_LANDLINE,
  DISPLAY_MOBILE,
  DISPLAY_NAME,
  OPT_EMERGENCY,
  OPT_GENERAL,
  PARTNER_EMAIL,
  PREFERENCE_ID,
  PROP_ADDRESS,
  SMS_PAST_DUE,
} from "./consts";
import { useGetUserPreferenceByUserId } from "@/services";
import { useEffect } from "react";
import { getRequiredFields } from "@/lib/utils";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import { schema } from "./validations";

const useStep3 = () => {
  const form = useForm<any>({
    defaultValues: {
      [PREFERENCE_ID]: "",
      [SMS_PAST_DUE]: false,
      [OPT_GENERAL]: false,
      [OPT_EMERGENCY]: false,
      [DISPLAY_NAME]: false,
      [PROP_ADDRESS]: false,
      [DISPLAY_EMAIL]: false,
      [DISPLAY_MOBILE]: false,
      [DISPLAY_LANDLINE]: false,
      [ADS]: false,
      [PARTNER_EMAIL]: false,
    },
    resolver: zodResolver(schema),
  });
   const communityDetail = useSelector(
    (state: RootState) => state.currentData.communityData
  );
  const _userDetails = useSelector(
    (state: RootState) => state.currentData.userData
  );
  const userId = _userDetails?.userId;
  // Dynamically determine required fields
  const requiredFields = getRequiredFields(schema);

  const userDataAction = useSelector(
    (state: RootState) => state.currentData.userDataAction
  );

  //get properties
  const {
    data: userPreference,
    isLoading: isLoadingUserPreference,
    isRefetching: isUserPreferenceRefetching,
  } = useGetUserPreferenceByUserId({
    userId: userId as string,
    communityId: communityDetail?.communityId,
    queryParams: {
      enabled: !!userId && userDataAction != "add",
    },
  });

  useEffect(() => {
    if (userPreference) {
      form.reset({
        [PREFERENCE_ID]:
          userPreference?.data?.[PREFERENCE_ID]?.toString() || "",
        [SMS_PAST_DUE]: userPreference?.data?.[SMS_PAST_DUE] || false,
        [OPT_GENERAL]: userPreference?.data?.[OPT_GENERAL] || false,
        [OPT_EMERGENCY]: userPreference?.data?.[OPT_EMERGENCY] || false,
        [DISPLAY_NAME]: userPreference?.data?.[DISPLAY_NAME] || false,
        [PROP_ADDRESS]: userPreference?.data?.[PROP_ADDRESS] || false,
        [DISPLAY_EMAIL]: userPreference?.data?.[DISPLAY_EMAIL] || false,
        [DISPLAY_MOBILE]: userPreference?.data?.[DISPLAY_MOBILE] || false,
        [DISPLAY_LANDLINE]: userPreference?.data?.[DISPLAY_LANDLINE] || false,
        [ADS]: userPreference?.data?.[ADS] || false,
        [PARTNER_EMAIL]: userPreference?.data?.[PARTNER_EMAIL] || false,
      });
    }
  }, [userPreference]);

  return {
    form,
    requiredFields,
    isLoadingUserPreference,
    userId,
    isUserPreferenceRefetching,
  };
};

export default useStep3;
